import { WordVoiceCommandIds, SelectionWhich } from '@augloop-types/voice';
var unsupportedCommands = new Set([
    WordVoiceCommandIds.Paste,
    WordVoiceCommandIds.Redo,
]);
export var ExperimentalCommandSetNames;
(function (ExperimentalCommandSetNames) {
    ExperimentalCommandSetNames["Tables"] = "Tables";
    ExperimentalCommandSetNames["ReadBack"] = "ReadBack";
})(ExperimentalCommandSetNames || (ExperimentalCommandSetNames = {}));
var experimentalCommandSets = new Map([
    [
        ExperimentalCommandSetNames.Tables,
        new Set([
            WordVoiceCommandIds.InsertTable,
            WordVoiceCommandIds.DeleteTable,
            WordVoiceCommandIds.NavigateTable,
            WordVoiceCommandIds.Navigation,
        ]),
    ],
    // Hack: ADO:4899550 - Switch from hardcoded string to WordVoiceCommandIds once we are able to update the types-voice pkg version.
    [
        ExperimentalCommandSetNames.ReadBack,
        new Set(['Word.Editing.ReadBack']),
    ],
]);
// Temporary change for V1
var commandsWithSelection = new Set([
    WordVoiceCommandIds.Bold,
    WordVoiceCommandIds.Italics,
    WordVoiceCommandIds.Underline,
    WordVoiceCommandIds.Highlight,
    WordVoiceCommandIds.Select,
    WordVoiceCommandIds.Superscript,
    WordVoiceCommandIds.Subscript,
    WordVoiceCommandIds.StrikeThrough,
    WordVoiceCommandIds.RemoveBold,
    WordVoiceCommandIds.RemoveItalics,
    WordVoiceCommandIds.RemoveUnderline,
    WordVoiceCommandIds.RemoveHighlight,
    WordVoiceCommandIds.RemoveSuperscript,
    WordVoiceCommandIds.RemoveSubscript,
    WordVoiceCommandIds.RemoveStrikeThrough,
    WordVoiceCommandIds.Delete,
]);
var enumKeysOfWordVoiceCommandIds = (
// Hack: ADO:4899550 - Switch from hardcoded string to WordVoiceCommandIds once we are able to update the types-voice pkg version.
Object.keys(WordVoiceCommandIds).concat(['Word.Editing.ReadBack']));
function getExperimentalCommandSetFromEnabledCommandSetNames(enabledExperimentalCommandsSetNames) {
    var enabledExperimentalCommands = new Set();
    enabledExperimentalCommandsSetNames.forEach(function (commandSetName) {
        var entry = experimentalCommandSets.get(commandSetName);
        if (entry != null) {
            entry.forEach(function (commandId) {
                enabledExperimentalCommands.add(commandId);
            });
        }
    });
    return enabledExperimentalCommands;
}
export var getValidCommandSet = function (enabledExperimentalCommandsSetNames) {
    var validCommandSet = new Set();
    var enabledExperimentalCommands = getExperimentalCommandSetFromEnabledCommandSetNames(enabledExperimentalCommandsSetNames);
    var allExperimentalCommands = getExperimentalCommandSetFromEnabledCommandSetNames(Object.keys(ExperimentalCommandSetNames));
    for (var _i = 0, enumKeysOfWordVoiceCommandIds_1 = enumKeysOfWordVoiceCommandIds; _i < enumKeysOfWordVoiceCommandIds_1.length; _i++) {
        var key = enumKeysOfWordVoiceCommandIds_1[_i];
        // If the command is experimental and is not enabled or it's unsupported, don't process it.
        if ((allExperimentalCommands.has(WordVoiceCommandIds[key]) &&
            !enabledExperimentalCommands.has(WordVoiceCommandIds[key])) ||
            unsupportedCommands.has(WordVoiceCommandIds[key])) {
            continue;
        }
        validCommandSet.add(WordVoiceCommandIds[key]);
    }
    return validCommandSet;
};
/** Returns true if this command is valid */
export var hasValidCommandValues = function (command) {
    if (commandsWithSelection.has(command.commandId)) {
        return !(command.selection && isInvalidSelection(command.selection, command.commandId));
    }
    return true;
};
/** Returns true if selection is invalid. We do don't support Next in selection (unless it is Navigation) */
var isInvalidSelection = function (selection, commandId) {
    return commandId !== WordVoiceCommandIds.Navigation && selection.which === SelectionWhich.Next;
};
/** Takes command and alters and returns the same.
 * This is a temporary fixe for results from AL */
export var alterCommandValue = function (command) {
    // If command is InsertComment, then keep only command text for floatie, and remove actual comment
    if (command.commandId === WordVoiceCommandIds.InsertComment) {
        var matchedPhrases = command.sourceText.match(/(.*comment[s]?)/);
        if (matchedPhrases) {
            command.sourceText = matchedPhrases[1]; // TODO: 4180157 - command.commandValue?.comment?.commentCommand;
        }
    }
    return command;
};
//# sourceMappingURL=validCommandUtil.js.map